import React, { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("thp_cart") || "[]"); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("thp_cart", JSON.stringify(items));
  }, [items]);

  const add = (product, color, size, quantity = 1) => {
    setItems((prev) => {
      const key = `${product.id}-${color}-${size}`;
      const found = prev.find((i) => i.key === key);
      if (found) return prev.map((i) => i.key === key ? { ...i, quantity: i.quantity + quantity } : i);
      return [...prev, {
        key, product_id: product.id, name: product.name, price: product.price,
        image: product.images?.[0], color, size, quantity,
      }];
    });
    toast.success("Added to bag", { description: `${product.name} · ${size}` });
  };

  const remove = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const setQty = (key, q) => setItems((prev) => prev.map((i) => i.key === key ? { ...i, quantity: Math.max(1, q) } : i));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
}
